import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BreadcrumbsContainer } from '@ibinder/common-frontend';
import BUILD_UP_CHIPS_DATA from '../../../../utils/reversePathRecursive';
import styled from 'styled-components';
import { BINDER_NAME } from '../../placeholderData';
import { useUserAccessBreadcrumb } from '../userAccessBreadcrumb';

const MANAGE_USERS_CRUMB_ID = 'manage-users';
const USER_RESOURCES_CRUMB_ID = 'user-resources';

const StyledBreadcrumbs = styled(BreadcrumbsContainer)`
  padding: 0.5rem 1rem;
`;

const isManageUsersChip = (chip) =>
  chip?.value?.type === 'Users' || chip?.name === 'Manage Users';

const BreadcrumbsComponent = ({ tabs, nodeData }) => {
  const { userName, assignmentsOpen, actions } = useUserAccessBreadcrumb();
  const baseChips = [
    { name: BINDER_NAME },
    // @ts-ignore
    ...BUILD_UP_CHIPS_DATA(nodeData)
  ];
  const CHIPS_DATA = userName
    ? [
        ...baseChips.map((chip) =>
          isManageUsersChip(chip)
            ? { ...chip, id: MANAGE_USERS_CRUMB_ID }
            : chip
        ),
        { name: userName, id: USER_RESOURCES_CRUMB_ID },
        ...(assignmentsOpen
          ? [{ name: 'Assignments', id: 'user-assignments' }]
          : [])
      ]
    : baseChips;

  const navigate = useNavigate();

  const handleClick = (id) => {
    if (id === MANAGE_USERS_CRUMB_ID) {
      actions.current.goToListing();
      return;
    }
    if (id === USER_RESOURCES_CRUMB_ID) {
      actions.current.goToResources();
      return;
    }
    if (id === undefined) {
      navigate(`/`);
    } else {
      navigate(`/tab/${id}`);
    }
  };

  return (
    <StyledBreadcrumbs
      loading={false}
      onClick={handleClick}
      chipsData={CHIPS_DATA}
    />
  );
};

export default BreadcrumbsComponent;
